export default __webpack_public_path__ + "static/media/sunsculpted5.15f667c3.jpg";